<script setup lang="ts">
import { COOKIE_CONSENT } from "shared/interfaces";

const { cookieConsent, updateCookieConsent } = useCommonStore();

const onSubmit = (consent: COOKIE_CONSENT) => {
	cookieConsent.isSeen = true;
	updateCookieConsent(consent);
};
</script>

<template>
	<div class="p-5 pb-6 bg-white border-green border-2">
		<div class="w-[480px] m-auto md:w-full sm:w-full xs:w-full">
			<div class="font-medium text-2xl xs:text-xl">
				{{ $t('cookieAgreement.title') }}
			</div>
			<div class="mt-3 text-sm">
				<span>{{ $t('cookieAgreement.description[0]') }}. {{ $t('cookieAgreement.description[1]') }} "{{ $t('cookiePreferences') }}"</span>
			</div>
			<div class="mt-5 flex gap-2 xs:flex-col">
				<AppButton
					class="w-4/6 xs:w-full"
					fill
					color="green"
					@click="onSubmit(COOKIE_CONSENT.GRANTED)"
				>
					{{ $t('accept') }}
				</AppButton>
				<AppButton
					class="w-2/6 xs:w-full"
					color="green"
					@click="onSubmit(COOKIE_CONSENT.DENIED)"
				>
					{{ $t('decline') }}
				</AppButton>
			</div>
		</div>
	</div>
</template>
